import { createColumnHelper } from '@tanstack/react-table';

import { FilterType, Position } from '../_openapi/portfolio-optimizer';
import { getAvailableAssetClasses, getAvailableAssetTypes, getAvailableSubAssetTypes } from '../utils/assetUtils';
import { AssetClassTag } from '../widgets/AssetClassTag';
import { baseCol, moneyCol, textCol } from '../widgets/Table/columnHelpers/colDef';
import { makeFieldAccessors } from '../widgets/Table/columnHelpers/makeFieldAccessors';
import { FlagCell } from '../widgets/Table/FlagCell';

const columnHelper = createColumnHelper<Position>();
const base = makeFieldAccessors(columnHelper, (row) => row.base);

export const positionListColumns = [
    base.date('tradeDate'),
    base.text('pId'),
    base.text('accountAlias'),
    base.text('portfolioGuid'),
    base.text('portfolioName'),
    base.text('householdName'),
    base.text('aC'),
    base.text('sId'),
    base.text('description'),
    columnHelper.accessor((row) => row.base.assetClass, {
        ...baseCol({ id: 'assetClass' }),
        cell: ({ getValue }) => <AssetClassTag assetClass={getValue()} />,
        meta: {
            filterOptionsFn: getAvailableAssetClasses,
            filterType: FilterType.LIST,
        },
    }),
    columnHelper.accessor(
        (row) => row.base.assetType,
        textCol<Position>({
            id: 'assetType',
            meta: {
                filterOptionsFn: getAvailableAssetTypes,
                filterType: FilterType.LIST,
            },
        }),
    ),
    columnHelper.accessor(
        (row) => row.base.subAssetType,
        textCol<Position>({
            id: 'subAssetType',
            meta: {
                filterOptionsFn: getAvailableSubAssetTypes,
                filterType: FilterType.LIST,
            },
        }),
    ),
    base.num('quantity'),
    base.money('closePrice'),
    base.money('marketValue'),
    base.money('netExposure'),
    base.money('grossExposure'),
    base.text('side'),
    base.money('costBasis'),
    base.money('pnlUnrealized'),
    base.num('returnUnrealized', { style: 'percent' }),
    base.text('referencePortfolio'),
    base.text('allocationType'),
    base.text('investmentAlgo'),
    base.text('investmentSleeve'),
    base.money('nav'),
    base.num('marketValuePercentOfNav', { style: 'percent' }),
    base.text('scId'),
    base.text('coId'),
    base.num('priceMultiplier'),
    base.num('contractMultiplier'),
    base.text('symbol'),
    base.text('primaryExchange'),
    base.text('cusip'),
    base.text('isin'),
    base.text('sedol'),
    columnHelper.accessor((row) => row.base.country, {
        ...baseCol({ id: 'country' }),
        cell: ({ getValue }) => <FlagCell alpha3={getValue()} />,
    }),
    base.text('mic'),
    base.text('gicsCode'),
    base.text('gicsSector'),
    base.text('gicsIndustry'),
    base.text('issuer'),
    base.num('coupon'),
    base.date('maturityDate'),
    base.date('issueDate'),
    base.date('expirationDate'),
    base.date('firstNoticeDate'),
    base.text('settlementMethod'),
    base.num('minTick'),
    base.text('putCall'),
    base.text('underlyingSymbol'),
    base.text('brokerId'),
    base.text('ndvrChainId'),
    columnHelper.accessor((row) => row.calculated?.accruedInterest, moneyCol<Position>({ id: 'accruedInterest' })),
];
